/** Bảng thành tựu (25) + sưu tập theo nhóm (M3). */
import { nhomSuuTapXong } from '../../core/thanh-tuu.js';
import type { GameController } from '../game-controller.js';
import { stylePanel, useCapNhat } from '../dung-chung.js';

export function PanelThanhTuu(props: { controller: GameController }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const nd = new Map(duLieu.noiDungThanhTuu.map((n) => [n.ma, n]));
  const ndSt = new Map(duLieu.noiDungSuuTap.map((n) => [n.nhom, n]));
  const daMo = new Set(state.thanhTuuDaMo);

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>
        🏆 Thành tựu ({state.thanhTuuDaMo.length}/{duLieu.thanhTuu.thanhTuu.length})
      </h3>
      <p style={{ fontSize: '12px', opacity: 0.8, margin: '0 0 8px' }}>
        Mở thành tựu được thưởng xu cao cấp 💎 ngay.
      </p>
      <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
        {duLieu.thanhTuu.thanhTuu.map((t) => {
          const mo = daMo.has(t.ma);
          const ten = nd.get(t.ma)?.ten ?? t.ma;
          const moTa = nd.get(t.ma)?.moTa ?? '';
          return (
            <div
              key={t.ma}
              style={{
                border: '1px solid #8a6a3a',
                borderRadius: '8px',
                padding: '6px 8px',
                marginBottom: '6px',
                opacity: mo ? 1 : 0.55,
              }}
            >
              <div style={{ fontWeight: 700, fontSize: '14px' }}>
                {mo ? '✅ ' : '🔒 '}
                {ten}
              </div>
              <div style={{ fontSize: '12px', opacity: 0.85 }}>{moTa}</div>
              <div style={{ fontSize: '12px', color: '#9fd0ff' }}>+{t.thuongXuCaoCap} 💎</div>
            </div>
          );
        })}
      </div>

      <h3 style={{ margin: '12px 0 8px' }}>📚 Sưu tập theo nhóm hàng</h3>
      <p style={{ fontSize: '12px', opacity: 0.8, margin: '0 0 8px' }}>
        Bán ít nhất 1 lần mỗi món trong nhóm để hoàn thành sưu tập.
      </p>
      {duLieu.suuTap.suuTap.map((s) => {
        const xong = nhomSuuTapXong(state, duLieu, s.nhom);
        const ten = ndSt.get(s.nhom)?.ten ?? s.nhom;
        const moTa = ndSt.get(s.nhom)?.moTa ?? '';
        const tongMon = duLieu.matHang.filter((m) => m.nhom === s.nhom).length;
        const daBan = duLieu.matHang.filter(
          (m) => m.nhom === s.nhom && (state.thongKe.monDaBan[m.ma] ?? 0) > 0,
        ).length;
        return (
          <div
            key={s.nhom}
            style={{
              border: '1px solid #8a6a3a',
              borderRadius: '8px',
              padding: '6px 8px',
              marginBottom: '6px',
            }}
          >
            <div style={{ fontWeight: 700, fontSize: '14px' }}>
              {xong ? '✅ ' : ''}
              {ten} ({daBan}/{tongMon})
            </div>
            <div style={{ fontSize: '12px', opacity: 0.85 }}>{moTa}</div>
            <div style={{ fontSize: '12px', color: '#9fd0ff' }}>+{s.thuongXuCaoCap} 💎</div>
          </div>
        );
      })}
    </div>
  );
}
